import { Shield, Home, Gauge, Sword, ScrollText, ArrowUpRight } from 'lucide-react'
import type { ComponentType } from 'react'
import PageHeader from '@/components/feature/PageHeader'
import Card from '@/components/base/Card'
import { rules } from '@/data/rules'
import { useLanguage } from '@/localization'

const icons: Record<string, ComponentType<{ size?: number; className?: string }>> = {
  shield: Shield,
  home: Home,
  gauge: Gauge,
  sword: Sword,
}

export default function RulesPage() {
  const { t } = useLanguage()

  return (
    <>
      <PageHeader
        title="Server Rules"
        subtitle="A few simple rules keep Uliunai friendly for everyone. Play fair, be kind, have fun."
      />

      <div className="max-w-5xl mx-auto px-4 py-12 space-y-6">
        <Card variant="grass">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <h2 className="text-lg font-extrabold text-slate-deep">
                {t('These are the Minecraft-specific rules')}
              </h2>
              <p className="text-sm text-slate-deep/70">
                {t(
                  "Griefing, x-ray, allowed mods and more. The universal Uliunai code of conduct (respect, fair play, clean chat) applies across every game.",
                )}
              </p>
            </div>
            <a
              href="https://uliunai.com/conduct"
              className="inline-flex shrink-0 items-center gap-1.5 font-bold text-grass-deep hover:text-grass-dark transition-colors"
            >
              {t('Community-wide conduct')} <ArrowUpRight size={16} />
            </a>
          </div>
        </Card>

        {rules.map((cat, i) => {
          const Icon = icons[cat.icon] ?? ScrollText
          return (
            <Card key={cat.title}>
              <div className="flex items-center gap-3 mb-4">
                <span className="w-11 h-11 rounded-xl bg-grass-dark text-white flex items-center justify-center shadow-block shrink-0">
                  <Icon size={22} />
                </span>
                <h2 className="text-xl font-extrabold text-slate-deep">
                  <span className="text-grass-deep">{i + 1}.</span> {t(cat.title)}
                </h2>
              </div>
              <ul className="space-y-2 pl-1">
                {cat.rules.map((r) => (
                  <li key={r} className="flex items-start gap-2 text-slate-deep/80">
                    <span className="mt-2 w-2 h-2 rounded-sm bg-grass-dark shrink-0" />
                    {t(r)}
                  </li>
                ))}
              </ul>
            </Card>
          )
        })}

        <p className="text-center text-sm text-slate-deep/60 pt-4">
          {t(
            'Staff have final say on rule enforcement. Breaking the rules may result in a warning, mute, kick or ban depending on severity.',
          )}
        </p>
      </div>
    </>
  )
}
